module.exports = __webpack_public_path__ + "static/media/map-grey.2478f927.svg";